module.exports = __webpack_public_path__ + "static/assets/dfe351ce5b149618f325a7c8b76acd92.png";